import { render, staticRenderFns } from "./ProposalList.vue?vue&type=template&id=5d8036f4&scoped=true&"
import script from "./ProposalList.vue?vue&type=script&lang=js&"
export * from "./ProposalList.vue?vue&type=script&lang=js&"
import style0 from "./ProposalList.vue?vue&type=style&index=0&id=5d8036f4&lang=scss&scoped=true&"
import style1 from "./ProposalList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8036f4",
  null
  
)

export default component.exports